<template>
  <div class="published-idea col-sm-12">
    <div
      class="published-idea-card"
      :class="{ 'my-publish-idea': idea.owner_id == userId }"
    >
      <text-expandable :text="idea.title"></text-expandable>
      <div class="evaluations">
        <div class="vote">
          <div class="icon-up" :class="{ 'icon-color-custom': idea.owner_id != userId && idea.userVoteValue == 1 }"></div>
          <span class="vote-counter">{{ idea.sumPostive }}</span>
        </div>
        <div class="vote">
          <div class="icon-up negative" :class="{ 'icon-color-custom': idea.owner_id != userId && idea.userVoteValue == -1 }"></div>
          <span class="vote-counter">{{ idea.sumNegative }}</span>
        </div>
      </div>

      <div class="idea-menu-icon" v-if="idea.owner_id == userId">
        <b-dropdown
          variant="link"
          right
          text="Right align"
          toggle-class="text-decoration-none"
          no-caret
          lazy
        >
          <template v-slot:button-content>
            <span class="icon-three-dots"></span>
          </template>
          <b-dropdown-item>
            <span class="deleteItem" @click="removeIdeaFromList()">Remove</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../api"

import TextExpandable from "./shared/TextExpandable.vue";

import deleteIdeasLists from "../gql/ideas_lists/deleteIdeasLists.gql";
import archiveIdea from "../gql/ideas/archiveIdea.gql";

export default {
  components: {
    TextExpandable,
  },
  data() {
    return {
      evaluations: {},
    };
  },
  computed: {
    userId() {
      return this.$store.state.user.id;
    },
  },
  methods: {
    removeIdeaFromList: function () {
      const idea_id = this.idea.id;
      const list_id = this.listId;

      this.$apollo
        .mutate({
          mutation: deleteIdeasLists,
          variables: {
            idea_id,
            list_id,
          },
        })
        .then((res) => {
          if (
            res.data.delete_ideas_lists.returning[0].idea.ideas_lists.length ==
            0
          ) {
            this.$apollo
              .mutate({
                mutation: archiveIdea,
                variables: {
                  idea_id,
                },
              })
              .then(() => {
                api.createEventTracking(
                  "idea-archived-public",
                  "idea-archived",
                  this.$store.state.user.id,
                  true
                );
              });
          }
        })
        .catch(function (error) {
          this.$rollbar.error(error);
          alert("Could not remove the idea from the list. Please try again later.");
        });
    },
  },
  beforeMount() {},
  props: {
    idea: {
      type: Object,
      required: true,
    },
    listId: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@use '../styles/theme.scss';

.published-idea {
  margin: auto;
  padding-left: 0;
  padding-right: 0;
  border: 0px;
  position: relative;
}

.published-idea .marker,
.published-idea .content {
  display: inline-block;
}

.published-idea div.published-idea-card {
  background-color: theme.$white-background;
  border-left: 4px solid theme.$text-placeholder;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  text-align: left;
  padding: 16px 16px 8px 12px;
  box-sizing: content-box;
  font-size: 14px;
  word-break: break-word;
}

.published-idea div.my-publish-idea {
  border-left: 4px solid theme.$accent-color;
}

.published-idea .evaluations {
  margin-top: 10px;
  text-align: left;
}

.published-idea .evaluations div {
  display: inline-block;
}

.vote {
  margin-right: 8px;
}

.published-idea div.idea-menu-icon {
  color: theme.$secondary-color;
  position: absolute;
  right: 0px;
  top: calc(50% - 20px);
}

.published-idea span.icon-three-dots {
  color: theme.$text-secondary-color;
  font-size: 24px;
}

.icon-up {
  font-size: 24px;
  vertical-align: bottom;
}

.icon-up::before {
  color: theme.$text-secondary-color !important;
}

.icon-color-custom::before {
  color: theme.$primary-color-dark !important;
}

.negative {
  transform: rotate(180deg);
}

.vote .negative ~ span {
  color: theme.$text-secondary-color;
}
</style>